const propsContextSupportingComponentsMap = {
  AccentBox: true,
  Action: true,
  ActionGroup: true,
  Avatar: true,
  Alert: true,
  AlertBadge: true,
  AlertIcon: true,
  Align: true,
  Badge: true,
  Button: true,
  Checkbox: true,
  CheckboxButton: true,
  CheckboxGroup: true,
  ColumnLayout: true,
  ComboBox: true,
  Content: true,
  ContextMenu: true,
  ContextMenuSection: true,
  ContextMenuTrigger: true,
  ContextualHelp: true,
  ContextualHelpTrigger: true,
  CopyButton: true,
  CounterBadge: true,
  CountryOptions: true,
  DatePicker: true,
  DateRangePicker: true,
  FieldDescription: true,
  FieldError: true,
  FileCard: true,
  FileCardList: true,
  FileField: true,
  FileDropZone: true,
  Header: true,
  Heading: true,
  Icon: true,
  Image: true,
  Initials: true,
  Label: true,
  LayoutCard: true,
  LightBox: true,
  Link: true,
  List: true,
  ListSummary: true,
  MenuItem: true,
  MenuTrigger: true,
  Message: true,
  MessageThread: true,
  Modal: true,
  ModalTrigger: true,
  Navigation: true,
  NavigationGroup: true,
  NumberField: true,
  Radio: true,
  Option: true,
  Popover: true,
  PopoverTrigger: true,
  PasswordCreationField: true,
  ProgressBar: true,
  RadioButton: true,
  RadioGroup: true,
  SearchField: true,
  Section: true,
  Segment: true,
  SegmentedControl: true,
  Select: true,
  Slider: true,
  Switch: true,
  Tabs: true,
  TabTitle: true,
  TestComponent: true,
  Text: true,
  TextArea: true,
  TextField: true,
  TimeField: true
};
const propsContextSupportingComponents = Object.keys(
  propsContextSupportingComponentsMap
);

export { propsContextSupportingComponents };
//# sourceMappingURL=index.mjs.map
